import api from './api';

const password = {
  forgot: payload => api.post('/auth/password', payload),
  recovery: payload => api.put('/auth/password', payload),
};

export default password;

